import {lazy} from 'react';
import LazyComponent from 'components/LazyComponent';

const intelDataRoutes = [
	{
		component: LazyComponent(lazy(() => import('./Create'))),
		path: '/intel-data/create',
	},
	{
		component: LazyComponent(lazy(() => import('./Update'))),
		path: '/intel-data/update/:id',
	},
];

export default intelDataRoutes;
